import { render, staticRenderFns } from "./Oficialia.vue?vue&type=template&id=7272c70f&"
import script from "./Oficialia.vue?vue&type=script&lang=js&"
export * from "./Oficialia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports